import React from 'react';
import { CheckIcon } from '@heroicons/react/24/solid';
import fonts from 'styles/typography.module.css';

export const AdminDesc: React.FC = () => {
  return (
    <div className={`text-gray-700 ${fonts.font}`}>
      <h4>Admin</h4>
      <div>
        <div className="flex items-center gap-2">
          <CheckIcon className="h-4 flex-shrink-0" />
          Add or approve new users
        </div>
      </div>
      <div>
        <div className="flex items-center gap-2">
          <CheckIcon className="h-4 flex-shrink-0" />
          Define user roles
        </div>
      </div>
      <div>
        <div className="flex items-center gap-2">
          <CheckIcon className="h-4 flex-shrink-0" />
          Choose billing details (plan, payment method etc)
        </div>
      </div>
    </div>
  );
};
AdminDesc.displayName = 'Settings.Profile.RolesDescription.AdminDesc';
